//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 150px;
    gap: 10px;
    & label {
        color: var(--dark-4);
        font-weight: 600;
        font-size: 14px;
    }
`;
export const Content = styled.div`
    position: relative;
    min-width: 135px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    &:not(.disabled):focus > div:first-child {
        color: var(--purple-2);
        border-color: var(--purple-2);
        & svg {
            fill: var(--purple-2);
        }
    }
`;